import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions } from "vuex";
import { NotAffiliationFinalized } from '~/components/modals';

export default {
    components: {
        NotAffiliationFinalized: NotAffiliationFinalized
    },
    data: function data() {
        return {
            dialog: false,
            logout: ''
        };
    },

    methods: _extends({}, mapMutations({
        emptyData: "affiliations/form/emptyData"
    }), {
        showModal: function showModal(data) {
            this.logout = data;
            this.dialog = true;
        },
        dontSaveData: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$emit('dontSaveData');
                                this.dialog = false;

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function dontSaveData() {
                return _ref.apply(this, arguments);
            }

            return dontSaveData;
        }(),
        close: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.$emit('saveData');
                                this.dialog = false;
                                this.emptyData();

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function close() {
                return _ref2.apply(this, arguments);
            }

            return close;
        }(),
        closeWithoutSave: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.$emit('closeWithoutSave');
                                this.dialog = false;
                                this.emptyData();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function closeWithoutSave() {
                return _ref3.apply(this, arguments);
            }

            return closeWithoutSave;
        }()
    })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/save-afiliation.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/save-afiliation.vue
// module chunks = 34